import { type ReactNode } from 'react';

import styles from './InputError.module.scss';

const InputError = ({ error = '' }: { error: ReactNode }) => {
  return <span className={styles.error}>{error}</span>;
};

export default InputError;
